import React from 'react';

import { Box, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';

export default function TabPanelArqueacaoAutomatica(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component="div">{children}</Typography>{' '}
        </Box>
      )}
    </div>
  );
}

TabPanelArqueacaoAutomatica.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
